// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PieChartFilledSvg from "@fishx/icons-svg/es/asn/PieChartFilled";
import FishxIcon from '../components/FishxIcon';

var PieChartFilled = function PieChartFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PieChartFilledSvg
  }));
};

PieChartFilled.displayName = 'PieChartFilled';
export default React.forwardRef(PieChartFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PieChartFilled.js
// module id = 3787
// module chunks = 0